
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  fullWidth?: boolean;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  fullWidth = false,
  className = '',
  ...props 
}: ButtonProps) {
  const baseClasses = 'font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center';
  
  const variants = {
    primary: 'bg-[#5C1A24] text-white hover:bg-[#4A1520] shadow-lg hover:shadow-xl',
    secondary: 'bg-[#3F3F3F] text-white hover:bg-[#2F2F2F] shadow-lg hover:shadow-xl',
    outline: 'border-2 border-[#5C1A24] text-[#5C1A24] hover:bg-[#5C1A24] hover:text-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
